var _circle, _circle2, _path, _circle3, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRound22AError = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 60 60",
  ref: ref
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 30,
  cy: 30,
  r: 10,
  fill: "#464D57"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 49,
  cy: 30.009,
  r: 6,
  fill: "#464D57",
  transform: "rotate(90 49 30.009)"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#f39898",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M53.243 25.766a6 6 0 0 1 0 8.485"
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 11,
  cy: 29.991,
  r: 6,
  fill: "#464D57",
  transform: "rotate(-90 11 29.991)"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#f39898",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M6.757 34.234a6 6 0 0 1 0-8.485"
})));
SvgRound22AError.viewBox = '0 0 60 60';
const ForwardRef = /*#__PURE__*/forwardRef(SvgRound22AError);
export default ForwardRef;